import { render, staticRenderFns } from "./BbppProductServicesLC.vue?vue&type=template&id=4bd76b36"
import script from "./BbppProductServicesLC.vue?vue&type=script&lang=js"
export * from "./BbppProductServicesLC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports